import { render, staticRenderFns } from "./IncidentPill.vue?vue&type=template&id=06e617d4&"
import script from "./IncidentPill.vue?vue&type=script&lang=js&"
export * from "./IncidentPill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports